/**
 * Generates a query string from the given parameters object.
 *
 * @param {Object} parameters - The parameters to convert to a query string.
 * @param {unknown} parameters.cursor - The cursor parameter.
 * @param {string|null} parameters.name - The name parameter.
 * @return {string} The generated query string.
 */
const queryString = (parameters) => Object.entries(parameters)
    .filter(([_, value]) => value !== null)
    .map(([key, value]) => `${key}=${value}`).join('&');

export default queryString;
